import React, { FC, memo, ReactElement } from 'react';
import { IComponentKey } from 'src/interfaces';

interface IListContainerProps<TItem> {
  ItemComponent: FC<TItem>;
  items: TItem[];
}

export const ListContainer = <TItem extends IComponentKey>(props: IListContainerProps<TItem>): ReactElement => (
  <>
    {props.items.map((item) => (
      <props.ItemComponent key={item.componentKey} {...item} />
    ))}
  </>
);
